import canvas from "canvas";

const cache: { [key: string]: HTMLImageElement } = {};
const cacheOnServer: { [key: string]: canvas.Image } = {};

class CachedAsyncImage {
  constructor(
    public readonly src: string,
    public readonly alpha: number | null = null
  ) {}

  public load(): Promise<HTMLImageElement> {
    if (cache[this.src]) {
      return Promise.resolve(cache[this.src]);
    }

    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        cache[this.src] = image;
        resolve(image);
      };
      image.onerror = reject;
      image.src = this.src;
    });
  }

  public loadOnServer(): Promise<canvas.Image> {
    if (cacheOnServer[this.src]) {
      return Promise.resolve(cacheOnServer[this.src]);
    }

    return new Promise((resolve, reject) => {
      const image = new canvas.Image();
      image.onload = () => {
        cacheOnServer[this.src] = image;
        resolve(image);
      };
      image.onerror = reject;
      image.src = this.src;
    });
  }
}

export default CachedAsyncImage;
